module.exports = __webpack_public_path__ + "static/media/verdeSam_wide.a655bf9f.jpg";